
<div fxLayout="row" fxLayoutAlign="center">
  <h3>Notice of Appearance</h3>
</div>

<form #agencyForm="ngForm">
  <mat-card>
    <mat-card-header style="margin-bottom: 20px;">
      <mat-card-title>Documents</mat-card-title>
      <br/>
    </mat-card-header>

    <mat-card-content fxLayout="column" fxLayoutGap="10px">


      <!-- File Upload Component -->
      <mat-form-field floatLabel="always" appearance="outline" style="width: 100%">
        <mat-label>Upload Request to Intervene Document (Only PDF and Excel files can be attached)</mat-label>
        <input matInput style="display: none" required/>

        <app-file-upload #fileUpload
                         [fileUploadInProgress]="fileUploadInProgress"
                         [wrongFileTypeMessage]="uploadDocMessage"
                         [requiredFileType]="requiredFileType"
                         [showAssociatedDocuments]="false"
                         (attachAssociatedDocOutput)="attachAssociatedDocOutput = $event"
                         (primaryEPDSFileListOutput)="onEPDSFileListChange($event, 'P')">
        </app-file-upload>
      </mat-form-field>

      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Comments</mat-label>
        <textarea matInput #commentsInput name="comments" maxlength="250" [(ngModel)]="comments"></textarea>
        <mat-label> ( Characters Remaining: {{ commentsInput.value.length }} / 250 )</mat-label>
      </mat-form-field>

    </mat-card-content>

    <mat-card-footer>

      <mat-card-actions fxLayout="row" fxLayoutAlign="center" fxLayoutGap="10px">
        <button mat-raised-button color="primary" class="spinner-black"
                [disabled]="fileUploadInProgress || !agencyForm.valid || (primaryFiles.length === 0)"
                (click)="onFormSubmit()">
          <div *appSpinner="fileUploadInProgress"></div>
          Submit
        </button>
        <button mat-raised-button color="warn" (click)="onFormCancel()">
          Cancel
        </button>
      </mat-card-actions>

    </mat-card-footer>
  </mat-card>

</form>
